<div
  *ngIf="isAdmin && isPublicBooking"
  class="matchmaking-toggle"
  aria-live="polite"
>
  <mat-slide-toggle
    #triggerButton
    color="primary"
    aria-label="Enable Match Making"
    [checked]="!!request"
    [disabled]="
      loading || submitting || !!request || (!request && !control?.canTrigger)
    "
    (change)="onToggle($event.checked)"
  >
    Match Making
  </mat-slide-toggle>

  <mat-progress-spinner
    *ngIf="loading || submitting"
    diameter="18"
    mode="indeterminate"
  ></mat-progress-spinner>

  <span *ngIf="loading">Checking availability…</span>
  <span *ngIf="!loading && !request && control?.canTrigger">
    {{ openPlacesLabel }}
  </span>
  <span *ngIf="!loading && !request && control && !control.canTrigger">
    {{ statusCopy }}
  </span>
  <span
    *ngIf="request"
    #statusMessage
    class="matchmaking-toggle__status"
    tabindex="-1"
  >
    {{ stateLabel }}
    <ng-container *ngIf="request.summary?.candidateCount">
      · {{ request.summary!.candidateCount }} eligible
      {{ request.summary!.candidateCount === 1 ? "player" : "players" }}
    </ng-container>
  </span>

  <span *ngIf="successMessage">{{ successMessage }}</span>
  <span *ngIf="error" class="matchmaking-toggle__error" role="alert">
    {{ error.message }}
    <button *ngIf="canRetry" mat-button type="button" (click)="retry()">
      Try again
    </button>
  </span>
</div>
